// src/data/eventsData.js

// Import event images
import SkillDevepImage from '../assets/skill_development.jpg';
import SkillDevepImage2 from '../assets/skill_development2_certificate.jpg';
import AgricultureFestival1 from '../assets/Globalkm251.jpg';
import ShreeGhorKashtodwarakPujan from '../assets/ghorKashtodharakBanner.jpg';
import Mauli from '../assets/Gurumauli.jpg';
import gangapurEvent from '../assets/Gangapur_event.jpg';
import Swayamrojgar from '../assets/vibhag-logos/swayam-rojgar.png';
import AgricultureFestival from "../assets/Globalkm25.jpg";
import JKMKrushi from "../assets/JKM26.jpg";
import MahakalAshtaBhairavPujan from "../assets/MahakalAshtaBhairavPujan.jpg";
import vishwashantiNewcastle from '../assets/vishwashanti_newcastle.png';
import dattaJayantiAkhandJap from '../assets/datta_jayanti_akhand_jap.jpeg';
import GurucharitaGangapurImage from '../assets/gurucharitra_gangapur.jpg';

// New event images for USA Mahotsav
import vishwashantiLA from '../assets/bayEvent02.png';
import vishwashantiBayArea from '../assets/bayEvent03.png';
import vishwashantiSeattle from '../assets/bayEvent01.png';
import vishwashantiPhoenix from '../assets/vishwashanti_phoenix.png';
import vishwashantiAtlanta from '../assets/vishwashanti_atlanta.png';
import vishwashantiBrampton from '../assets/vishwashanti_brampton.png';
import pithapurPadukaPujan from '../assets/pithapur_paduka_pujan.jpeg'

export const eventsData = {
  mr: [
    {
      id: 1,
      title: "श्री घोर कष्टोद्वारक पूजन",
      subtitle: "विशेष पूजन कार्यक्रम",
      date: "२۴ - २६ ऑक्टोबर २०२५",
      endDate: "2025-10-26",
      thumbnail: ShreeGhorKashtodwarakPujan,
      photos: [ShreeGhorKashtodwarakPujan, gangapurEvent],
      videos: [
        {
          title: "घोर कष्टोद्वारक पूजन",
          url: "https://www.youtube.com/embed/EH8bHnCeXnM?si=NdfXGm2VN15R46jn"
        }
      ],
      description: "श्री घोर कष्टोद्वारक पूजन हे मानसिक, शारीरिक व आर्थिक संकटांपासून मुक्ती देणारे अत्यंत प्रभावी पूजन आहे. या पूजनाद्वारे श्रद्धाळूंना परमेश्वर कृपा प्राप्त होते.",
      fullContent: `
        <h3>🙏 श्री घोर कष्टोद्वारक पूजन</h3>
        <p>हे पूजन जीवनातील गंभीर समस्यांवर, मानसिक-शारीरिक कष्टांवर आणि आर्थिक अडचणींवर उपाय म्हणून करण्यात येते.</p>

        <h4>✨ पूजनाचे लाभ:</h4>
        <ul>
          <li>शारीरिक व मानसिक कष्टांचे निवारण</li>
          <li>गंभीर आर्थिक व कौटुंबिक समस्यांपासून मुक्ती</li>
          <li>व्यवसाय, नोकरी व आरोग्यासाठी विशेष फलदायी</li>
        </ul>

        <h4>📅 तारीख:</h4>
        <p>२४ ते २६ ऑक्टोबर २०२५</p>

        <h4>📍 स्थळ:</h4>
        <p><strong>अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ शाखा</strong><br>गणगापुर (कर्नाटक)</p>

        <h4>📞 संपर्क:</h4>
        <p>8956630913 / 8956630914 / 8956630915 / 7709107339 / 9970447132</p>
      `,
      venue: {
        name: "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ शाखा",
        address: "गणगापुर, कर्नाटक",
        mapLink: "https://maps.app.goo.gl/yrvTaTonq7BCPkrs6"
      },
      highlights: [
        "शारीरिक, मानसिक व आर्थिक कष्टांपासून मुक्ती",
        "गंभीर समस्यांचे समाधान",
        "गुरुप्रसाद व आशीर्वाद लाभ"
      ],
      timings: "२४ ते २६ ऑक्टोबर २०२५",
      location: "गणगापुर, कर्नाटक"
    },
    {
      id: 2,
      title: "जागतिक कृषी महोत्सव 2026",
      subtitle: "सेंद्रिय व नैसर्गिक शेतीचा उत्सव",
      date: "जानेवारी 23-27, 2026",
      endDate: "2026-01-27",
      thumbnail: JKMKrushi,
      photos: [JKMKrushi, AgricultureFestival, AgricultureFestival1],
      videos: [
        {
          title: "कृषी महोत्सव 2024 हायलाइट्स",
          url: "https://www.youtube.com/embed/dohcsIlAbrk"
        },
        {
          title: "सेंद्रिय शेती तंत्रे",
          url: "https://www.youtube.com/embed/_Y7Icpgqcbc"
        }
      ],
      description: "कृषी महोत्सव हा श्री स्वामी समर्थ सेवा मार्ग, दिंडोरी अंतर्गत नाशिक येथे आयोजित केलेला आंतरराष्ट्रीय कृषी उत्सव आहे. हा महोत्सव सेंद्रिय शेती, शाश्वत शेती आणि पारंपारिक शेती पद्धतींना प्रोत्साहन देतो.",
      fullContent: `
        <h3>🌾 जागतिक कृषी महोत्सव 2026</h3>
        <p>कृषी महोत्सव हा श्री स्वामी समर्थ सेवा मार्ग, दिंडोरी अंतर्गत नाशिक येथे आयोजित केलेला आंतरराष्ट्रीय कृषी उत्सव आहे.</p>
        
        <h4>✨ मुख्य आकर्षणे:</h4>
        <ul>
          <li>आंतरराष्ट्रीय शेतकरी प्रदर्शन</li>
          <li>सेंद्रिय शेती कार्यशाळा आणि प्रात्यक्षिके</li>
          <li>कृषी उपकरणे प्रदर्शन</li>
          <li>पारंपारिक बियाणे संरक्षण केंद्र</li>
          <li>पशुधन आणि दुग्धव्यवसाय मार्गदर्शन</li>
          <li>मोफत माती परीक्षण शिबीर</li>
          <li>प्रगतीशील शेतकऱ्यांसाठी पुरस्कार</li>
        </ul>

        <h4>📍 स्थळ:</h4>
        <p><strong>कृषी प्रदर्शन मैदान, नाशिक</strong><br>
        कृषी महोत्सव मैदान, दिंडोरी रोड, नाशिक, महाराष्ट्र 422202</p>

        <h4>🕐 वेळ:</h4>
        <p>सकाळी 8:00 - रात्री 8:00 (सर्व 5 दिवस)</p>

        <h4>🌐 अधिक माहितीसाठी:</h4>
        <p><a href="https://www.krushimahotsav.org/" target="_blank">www.krushimahotsav.org</a></p>
      `,
      venue: {
        name: "कृषी प्रदर्शन मैदान, नाशिक",
        address: "कृषी महोत्सव मैदान, दिंडोरी रोड, नाशिक, महाराष्ट्र 422202",
        mapLink: "https://www.krushimahotsav.org/"
      },
      highlights: [
        "आंतरराष्ट्रीय शेतकरी प्रदर्शन",
        "सेंद्रिय शेती कार्यशाळा आणि प्रात्यक्षिके",
        "कृषी उपकरणे प्रदर्शन",
        "पारंपारिक बियाणे संरक्षण केंद्र",
        "पशुधन आणि दुग्धव्यवसाय मार्गदर्शन",
        "मोफत माती परीक्षण शिबीर",
        "प्रगतीशील शेतकऱ्यांसाठी पुरस्कार"
      ],
      timings: "सकाळी 8:00 - रात्री 8:00 (सर्व 5 दिवस)",
      location: "नाशिक, महाराष्ट्र"
    },
    {
      id: 3,
      title: "कौशल्य प्रशिक्षण उपक्रम",
      subtitle: "स्वयंरोजगार आणि व्यावसायिक कार्यशाळा",
      date: "नोव्हेंबर 02, 2025",
      endDate: "2025-11-02",
      thumbnail: Swayamrojgar,
      photos: [Swayamrojgar, SkillDevepImage2, SkillDevepImage],
      videos: [
        {
          title: "यशोगाथा",
          url: "https://www.youtube.com/embed/6JSiEUtimkk?si=wpGVoG8ydYtW1CUS"
        }
      ],
      description: "युवक आणि महिलांना व्यावसायिक प्रशिक्षण, उद्योजकता मार्गदर्शन आणि स्वयंरोजगार संधींसह सक्षम करण्याचा एक व्यापक कौशल्य विकास कार्यक्रम.",
      fullContent: `
        <h3>💼 कौशल्य प्रशिक्षण उपक्रम</h3>
        <p>युवक आणि महिलांना व्यावसायिक प्रशिक्षण, उद्योजकता मार्गदर्शन आणि स्वयंरोजगार संधींसह सक्षम करण्याचा एक व्यापक कौशल्य विकास कार्यक्रम.</p>
        
        <h4>✨ मुख्य आकर्षणे:</h4>
        <ul>
          <li>शिवणकाम आणि वस्त्र निर्मिती</li>
          <li>संगणक प्रशिक्षण आणि डिजिटल साक्षरता</li>
          <li>अन्न प्रक्रिया आणि पॅकेजिंग</li>
          <li>सौंदर्य आणि निरोगीपणा अभ्यासक्रम</li>
          <li>लघु व्यवसाय व्यवस्थापन</li>
          <li>पूर्णत्वावर मोफत प्रमाणपत्र</li>
          <li>नोकरी मिळविण्यात मदत</li>
        </ul>

        <h4>📍 स्थळ:</h4>
        <p><strong>सेवा मार्ग प्रशिक्षण केंद्र, दिंडोरी</strong><br>
        श्री गुरुपीठ परिसर, दिंडोरी, नाशिक, महाराष्ट्र 422202</p>

        <h4>🕐 वेळ:</h4>
        <p>सकाळी 9:00 - संध्याकाळी 5:00 (6 दिवसीय कार्यक्रम)</p>
      `,
      venue: {
        name: "सेवा मार्ग प्रशिक्षण केंद्र, दिंडोरी",
        address: "श्री गुरुपीठ परिसर, दिंडोरी, नाशिक, महाराष्ट्र 422202",
        mapLink: "https://maps.app.goo.gl/WhNPhR37o5iTJv558"
      },
      highlights: [
        "शिवणकाम आणि वस्त्र निर्मिती",
        "संगणक प्रशिक्षण आणि डिजिटल साक्षरता",
        "अन्न प्रक्रिया आणि पॅकेजिंग",
        "सौंदर्य आणि निरोगीपणा अभ्यासक्रम",
        "लघु व्यवसाय व्यवस्थापन",
        "पूर्णत्वावर मोफत प्रमाणपत्र",
        "नोकरी मिळविण्यात मदत"
      ],
      timings: "सकाळी 9:00 - संध्याकाळी 5:00 (6 दिवसीय कार्यक्रम)",
      location: "दिंडोरी, नाशिक"
    },
    {
      id: 4,
      title: "महाकालअष्टभैरव पूजन व महाकाली याग",
      subtitle: "विशेष धार्मिक कार्यक्रम",
      date: "१२ नोव्हेंबर २०२५",
      endDate: "2025-11-12",
      thumbnail: MahakalAshtaBhairavPujan,
      photos: [MahakalAshtaBhairavPujan],
      videos: [],
      description:
        "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ, त्र्यंबकेश्वर येथे महाकालअष्टभैरव पूजन व महाकाली याग आयोजित करण्यात येत आहे. राष्ट्र कल्याण व समस्त मानवजातीच्या संरक्षणासाठी हा विशेष धार्मिक कार्यक्रम आहे.",
      fullContent: `
        <h3>!! श्री स्वामी समर्थ !!</h3>
        <h4>अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ, त्र्यंबकेश्वर</h4>

        <h3>🙏 महाकालअष्टभैरव व पूजन व महाकाली याग 🙏</h3>
        <p>🗓 दिनांक: १२ नोव्हेंबर २०२५</p>
        <p>📍 स्थळ: अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ, त्र्यंबकेश्वर</p>

        <h4>🌺 कार्यक्रमाची रूपरेषा:</h4>
        <ul>
          <li>🕙 १०:०० ते १०:२५ – सेवेकरी बैठक नियोजन</li>
          <li>🕥 १०:३० – नैवेद्य आरती</li>
          <li>🕥 १०:४० ते ३:०० – महासंकल्प : राष्ट्र कल्याणार्थ तसेच समस्त सेवेकरी व मानवजातीच्या संरक्षणार्थ</li>
          <li>* अष्टभैरव मंत्र तथा महाकालभैरव अष्टक हवन</li>
          <li>* महाकाली याग (संस्कृत दुर्गासप्तशती)</li>
          <li>* आदरणीय चंद्रकांत दादासाहेबांचे अमृततुल्य प्रसादरूपी हितगुज</li>
          <li>🕥 ४.०० ते ५:०० – दरबारात कालभैरव महाराजांचे सर्व सेवेकऱ्यांच्या हस्ते पूजन व सांगता</li>
        </ul>

        <p>ह्या विशेष पूजेसाठी गूगल फॉर्म वर आपली नावे नोंद करावी: 
        <a href="https://tinyurl.com/MahakalashtBhairavPujan" target="_blank">https://tinyurl.com/MahakalashtBhairavPujan</a></p>

        <h4>🪔 आणावयाचे साहित्य:</h4>
        <p>ताम्हण, पळी-पेला, देवघरातील भैरव देवतेचा टाक (टाक नसेल तर शिवलिंग), हल्दी-कुंकू-अष्टगंध, अक्षदा, खडीसाखर, टाक ठेवायला वस्त्र, पाण्याची बाटली, देव पुसायला वस्त्र/नॅपकिन, नित्यसेवा ग्रंथ, संस्कृत दुर्गासप्तशती ग्रंथ, जपमाळ, श्रीफळ १, इ.</p>
      `,
      venue: {
        name: "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ",
        address: "त्र्यंबकेश्वर, नाशिक, महाराष्ट्र",
        mapLink: "https://maps.app.goo.gl/HG5qHR3WwQLivnpT8"
      },
      highlights: [
        "महाकालअष्टभैरव पूजन व महाकाली याग",
        "राष्ट्र कल्याणार्थ व मानवजातीच्या संरक्षणासाठी विशेष पूजन",
        "संस्कृत दुर्गासप्तशती पठण व हवन"
      ],
      timings: "१०:०० ते ५:००",
      location: "त्र्यंबकेश्वर, नाशिक"
    },
    {
      id: 5,
      title: "विश्वशांती महोत्सव २०२५: लॉस एंजेलिस",
      subtitle: "जागतिक शांततेचा आनंदमय उत्सव",
      date: "०८ नोव्हेंबर २०२५",
      endDate: "2025-11-08",
      thumbnail: vishwashantiLA,
      photos: [vishwashantiLA],
      videos: [],
      description: "लॉस एंजेलिस, कॅलिफोर्निया येथे अत्यंत उत्साहात साजरा झालेल्या ह्या महोत्सवात महाआरती, स्वामी पादुका दर्शन, स्वामी पालखी, श्रीयंत्र पूजन, महाप्रसाद आणि पारंपरिक नृत्यांचा समावेश होता. अनेक मान्यवर आणि समाजसेवक उपस्थित होते.",
      fullContent: `
        <h3>🙏 विश्वशांती महोत्सव २०२५: लॉस एंजेलिस, कॅलिफोर्निया</h3>
        <p>लॉस एंजेलिस, कॅलिफोर्निया येथे विश्वशांती महोत्सव २०२५ (USA) अत्यंत आनंदाने साजरा करण्यात आला. संपूर्ण राज्यातील स्वामी भक्तांनी माननीय नितीनभाऊ आणि श्री स्वामी समर्थ सेवा मार्गाचे हार्दिक स्वागत केले.</p>
        
        <h4>✨ कार्यक्रमाची वैशिष्ट्ये:</h4>
        <ul>
          <li>महाआरती, स्वामी पादुका दर्शन, आणि स्वामी पालखी मिरवणूक</li>
          <li>चक्रराज श्रीयंत्र पूजन आणि महाप्रसाद (अन्नदान)</li>
          <li>लहान मुलांसह सर्वांचा पारंपरिक नृत्यात उत्साहपूर्ण सहभाग</li>
          <li>मागील वर्षी आध्यात्मिक मार्गदर्शन घेतलेल्या भक्तांनी त्यांचे अनुभव सांगितले.</li>
        </ul>

        <h4>👨‍👩‍👧‍👦 बालसंस्कार विभाग:</h4>
        <p>"आंतरिक शांतीतून विश्वशांती" या स्पर्धेसह नाटिका आणि सादरीकरणाला उत्तम प्रतिसाद मिळाला. बालसंस्कार सेवेकऱ्यांना मूल्यशिक्षण वर्गातील उत्कृष्ट कामगिरीबद्दल माननीय नितीनभाऊंच्या हस्ते प्रमाणपत्रे देण्यात आली.</p>
        
        <h4>🌟 प्रमुख उपस्थिती:</h4>
        <p>सौ. अपर्णा हांडे जी (अध्यक्ष, SMAP-LA), श्री. केवल कांडा (अध्यक्ष, युनायटेड इंडियन असोसिएशन), डॉ. श्रीकृष्ण वैद्य (न्यूरोलॉजिस्ट), आणि इतर अनेक मान्यवर उपस्थित होते.</p>
      `,
      venue: {
        name: "लॉस एंजेलिस",
        address: "लॉस एंजेलिस, कॅलिफोर्निया, USA",
        mapLink: "https://maps.google.com/?q=Los+Angeles+California"
      },
      highlights: [
        "महाआरती आणि स्वामी पादुका दर्शन",
        "बालसंस्कार नाटिका आणि स्पर्धा",
        "प्रतिष्ठित समाजसेवकांची उपस्थिती",
        "आध्यात्मिक मार्गदर्शनाच्या यशोगाथा"
      ],
      timings: "संपूर्ण दिवस",
      location: "लॉस एंजेलिस, कॅलिफोर्निया"
    },
    {
      id: 6,
      title: "विश्वशांती महोत्सव २०२५: बे एरिया",
      subtitle: "सेवा, संस्कार आणि शांतीचा प्रसार",
      date: "०९ नोव्हेंबर २०२५",
      endDate: "2025-11-09",
      thumbnail: vishwashantiBayArea,
      photos: [vishwashantiBayArea],
      videos: [],
      description: "परमपूज्य गुरुमाऊलींच्या आशीर्वादाने, बे एरिया, कॅलिफोर्निया येथे विश्वशांती महोत्सव साजरा करण्यात आला. या कार्यक्रमात सेवा, संस्कार आणि शांतीचा संदेश देण्यात आला.",
      fullContent: `
        <h3>🙏 विश्वशांती महोत्सव २०२५: बे एरिया, कॅलिफोर्निया</h3>
        <p>परमपूज्य गुरुमाऊलींच्या आशीर्वादाने, श्री स्वामी समर्थ गुरुपीठ, USA द्वारे बे एरिया, कॅलिफोर्निया येथे विश्वशांती महोत्सव २०२५ मोठ्या उत्साहात साजरा करण्यात आला. स्वामी भक्तांनी श्री स्वामी समर्थ सेवा मार्ग आणि माननीय नितीनभाऊंचे हार्दिक स्वागत केले.</p>

        <h4>✨ मुख्य आकर्षणे:</h4>
        <ul>
          <li>चक्रराज श्रीयंत्र पूजन आणि श्री स्वामी समर्थ महाराज पादुका अभिषेक</li>
          <li>आदरणीय नितीनभाऊ यांचे प्रेरणादायी हितगुज आणि आध्यात्मिक मार्गदर्शन</li>
          <li>मुलांनी सादर केलेली गुरुप्रणाली आणि गुरुपीठ कार्यावरील नाटिका</li>
          <li>विश्वशांती प्रार्थना, महाआरती आणि उत्साही पालखी सेवा</li>
          <li>युवक संघाद्वारे हिवाळी कपडे दान अभियान</li>
        </ul>
        
        <h4>🎨 बालसंस्कार आणि युवा विभाग:</h4>
        <ul>
          <li>ज्येष्ठ नागरिकांसाठी ग्रीटिंग कार्ड्स, बुकमार्क्स बनवण्याची सेवा</li>
          <li>सरस्वती पूजन आणि मातृ-पितृ पूजन</li>
          <li>सामाजिक हितासाठी 'असिस्टिव्ह टेक्नॉलॉजी' स्पर्धा</li>
        </ul>

        <p>संपूर्ण राज्यातील भक्त मोठ्या भक्तिभावाने आणि उत्साहाने स्वामी महाराजांचा सेवा, संस्कार आणि शांतीचा संदेश पसरवण्यासाठी समर्पित या आध्यात्मिक कार्यक्रमात सहभागी झाले.</p>
      `,
      venue: {
        name: "बे एरिया",
        address: "बे एरिया, कॅलिफोर्निया, USA",
        mapLink: "https://maps.google.com/?q=Bay+Area+California"
      },
      highlights: [
        "चक्रराज श्रीयंत्र पूजन",
        "युवकांचे हिवाळी वस्त्रदान अभियान",
        "सहाय्यक तंत्रज्ञान स्पर्धा",
        "आदरणीय नितीनभाऊंचे प्रेरणादायी हितगुज",
        "मातृ-पितृ पूजन आणि बालसंस्कार"
      ],
      timings: "संपूर्ण दिवस",
      location: "बे एरिया, कॅलिफोर्निया"
    },
    {
      id: 7,
      title: "विश्वशांती महोत्सव २०२५: सिएटल",
      subtitle: "आध्यात्मिक शांतीचा संदेश",
      date: "०७ नोव्हेंबर २०२५",
      endDate: "2025-11-07",
      thumbnail: vishwashantiSeattle,
      photos: [vishwashantiSeattle],
      videos: [],
      description: "श्री स्वामी समर्थ महाराज व परमपूज्य गुरुमाऊलींच्या दिव्य आशीर्वादाने, सिएटल येथे विश्वशांती महोत्सव मोठ्या भक्तिभावाने साजरा करण्यात आला. सुमारे १५० भक्तांनी या आध्यात्मिक कार्यक्रमात सहभाग घेतला.",
      fullContent: `
        <h3>🌍 विश्वशांती महोत्सव – सिएटल 🌍</h3>
        <p>श्री स्वामी समर्थ महाराज व परमपूज्य गुरुमाऊलींच्या दिव्य आशीर्वादाने, सिएटल विश्वशांती महोत्सव मोठ्या भक्तिभावाने साजरा करण्यात आला. सुमारे १५० भक्तांनी या कार्यक्रमात सहभाग घेतला.</p>

        <h4>✨ कार्यक्रमाची वैशिष्ट्ये:</h4>
        <ul>
          <li>संध्याकाळी ५:०० वाजता लक्ष्मीप्राप्ति सेवेने कार्यक्रमाची सुरुवात</li>
          <li>आगमन, औक्षण, दीपपालन आणि माननीय नितीनभाऊंचा सत्कार</li>
          <li>१२ मुलांनी सादर केलेला बालसंस्कार कार्यक्रम: "विश्वशांती तीन स्तंभांवर अवलंबून आहे - स्वतःशी शांती, इतरांशी शांती आणि एकतेत शांती"</li>
          <li>श्री स्वामी समर्थ महाराज व परमपूज्य गुरुमाऊलींबद्दल माहितीपूर्ण सादरीकरण</li>
          <li>आरती, माननीय नितीनभाऊंचा परिचय व हितगुज</li>
          <li>मुख्य अतिथी श्री. वामशी रेड्डी (TTA चे अध्यक्ष आणि अनेक गैर-नफा संस्थांचे संस्थापक) यांचा सत्कार</li>
          <li>दर्शन सोहळा, पालखी मिरवणूक आणि वैयक्तिक मार्गदर्शन सत्रे</li>
        </ul>

        <h4>🙏 सामाजिक उपक्रम:</h4>
        <p>गरजूंना मदत करण्यासाठी कॅन्ड आणि न-नाशवंत अन्नपदार्थ गोळा करणारा खाद्य अभियान आयोजित करण्यात आला.</p>

        <p>पवित्र श्री स्वामी समर्थ पादुका पूजन, भक्तिपूर्ण पालखी सोहळा, बालसंस्कार विभागाच्या मुलांनी केलेली प्रेरणादायी सादरीकरण आणि आध्यात्मिक मार्गदर्शनाने प्रत्येकाच्या हृदयात भक्ती, आनंद आणि शांती भरून आली.</p>
      `,
      venue: {
        name: "सिएटल",
        address: "सिएटल, वॉशिंग्टन, USA",
        mapLink: "https://maps.google.com/?q=Seattle+Washington"
      },
      highlights: [
        "पवित्र श्री स्वामी समर्थ पादुका पूजन",
        "बालसंस्कार विभागाचा प्रेरणादायी कार्यक्रम",
        "गरजूंसाठी खाद्य दान अभियान",
        "मुख्य अतिथी श्री. वामशी रेड्डी यांची उपस्थिती",
        "भक्तिमय वातावरण व वैयक्तिक मार्गदर्शन"
      ],
      timings: "संध्याकाळी ५:०० पासून",
      location: "सिएटल, वॉशिंग्टन"
    },
     {
      id: 8,
      title: "विश्वशांती महोत्सव २०२५: फिनिक्स",
      subtitle: "भक्ती, एकता आणि शांतीचा उत्सव",
      date: "१४ नोव्हेंबर २०२५",
      endDate: "2025-11-14",
      thumbnail: vishwashantiPhoenix,
      photos: [vishwashantiPhoenix],
      videos: [],
      description: "फिनिक्स येथे विश्वशांती महोत्सव २०२५ भक्ती आणि उत्साहाने साजरा करण्यात आला. स्वामी भक्त, कुटुंबे आणि समाजसेवकांनी या आध्यात्मिक कार्यक्रमात सहभाग घेतला.",
      fullContent: `
        <h3>🙏 विश्वशांती महोत्सव २०२५: फिनिक्स</h3>
        <p>फिनिक्स येथे विश्वशांती महोत्सव २०२५ भक्ती आणि उत्साहाने साजरा करण्यात आला, ज्यात स्वामी भक्त, कुटुंबे आणि समाजसेवक या आध्यात्मिक उत्थानाच्या कार्यक्रमात एकत्र आले. माननीय डॉ. नितीनभाऊंच्या आध्यात्मिक मार्गदर्शनाने सर्व उपस्थितांना खूप प्रेरणा मिळाली.</p>

        <h4>✨ कार्यक्रमाची वैशिष्ट्ये:</h4>
        <ul>
          <li>पादुका पूजन, चक्रराज श्रीयंत्र पूजन</li>
          <li>मातृ-पितृ पूजन, मुलांसाठी सरस्वती पूजन</li>
          <li>बालसंस्कार कार्यक्रम, युवा स्वयंसेवक उपक्रम</li>
          <li>पालखी मिरवणूक, अन्नदान अभियान</li>
          <li>महाआरती आणि महाप्रसाद</li>
        </ul>

        <h4>🌟 मान्यवर उपस्थिती:</h4>
        <p>श्री शिर्डी साईबाबा मंदिर (उत्तर फिनिक्स) चे पदाधिकारी व भक्त, हर्षद देसाई (फिनिक्स मेट्रो महाराष्ट्र मंडळ), सुष्मा ठाकूर-पाटणकर (AVATAR थिएटर्स ऑफ ॲरिझोना), प्रसाद कोराने (सेवा इंटरनॅशनल आणि HSS), दीपाली मंडळकर (श्री गजानन महाराज परिवार), आणि रत्नावली पाटणे (अध्यक्ष, छत्रपती शिवाजी महाराज आंतरराष्ट्रीय परिवार) यांनी कार्यक्रमाची शोभा वाढवली.</p>

        <p>या महोत्सवाने परमपूज्य गुरुमाऊलींचा स्वामी सेवा, संस्कार आणि शांतीचा संदेश फिनिक्स समुदायात पसरवला आणि शांती, भक्ती आणि एकतेचा संदेश दिला.</p>
      `,
      venue: {
        name: "फिनिक्स",
        address: "फिनिक्स, ॲरिझोना, USA",
        mapLink: "https://maps.google.com/?q=Phoenix+Arizona"
      },
      highlights: [
        "पादुका पूजन आणि चक्रराज श्रीयंत्र पूजन",
        "मातृ-पितृ पूजन आणि बालसंस्कार कार्यक्रम",
        "अन्नदान अभियान",
        "प्रतिष्ठित समाजसेवकांची उपस्थिती",
        "माननीय डॉ. नितीनभाऊंचे प्रेरणादायी हितगुज"
      ],
      timings: "संपूर्ण दिवस",
      location: "फिनिक्स, ॲरिझोना"
    },
    {
      id: 9,
      title: "विश्वशांती महोत्सव २०२५: अटलांटा",
      subtitle: "सेवा आणि संस्कार - पूजेचा सर्वोत्तम प्रकार",
      date: "१५ नोव्हेंबर २०२५",
      endDate: "2025-11-15",
      thumbnail: vishwashantiAtlanta,
      photos: [vishwashantiAtlanta],
      videos: [],
      description: "अटलांटा येथे १५ नोव्हेंबर २०२५ रोजी विश्वशांती महोत्सव मोठ्या भक्तीभावाने साजरा करण्यात आला. USA च्या दहा वेगवेगळ्या राज्यांतील शेकडो स्वामी भक्तांनी माननीय डॉ. नितीनभाऊ आणि श्री गुरुपीठातून आलेल्या 'श्री स्वामी समर्थ महाराजांच्या पवित्र पादुका'चे हार्दिक स्वागत केले.",
      fullContent: `
        <h3>🙏 विश्वशांती महोत्सव २०२५: अटलांटा, जॉर्जिया</h3>
        <p>अटलांटा येथे १५ नोव्हेंबर २०२५ रोजी विश्वशांती महोत्सव मोठ्या भक्तीभावाने साजरा करण्यात आला. USA च्या दहा वेगवेगळ्या राज्यांतील शेकडो स्वामी भक्तांनी माननीय डॉ. नितीनभाऊ आणि श्री गुरुपीठातून आलेल्या 'श्री स्वामी समर्थ महाराजांच्या पवित्र पादुका'चे हार्दिक स्वागत केले.</p>

        <h4>✨ कार्यक्रमाची वैशिष्ट्ये:</h4>
        <ul>
          <li>पादुका पूजन आणि चक्रराज श्रीयंत्र पूजन</li>
          <li>महाआरती आणि जागतिक शांतीसाठी सामूहिक विश्वशांती प्रार्थना</li>
          <li>माननीय डॉ. नितीनभाऊंचे प्रेरणादायी प्रवचन</li>
          <li>भक्तिमय पालखी मिरवणूक</li>
          <li>मुले आणि युवकांनी मातृ-पितृ पूजन, सरस्वती पूजन, सणांचे प्रदर्शन, प्रदर्शने आणि करिअर मार्गदर्शन उपक्रमात सहभाग</li>
          <li>बालसंस्कार मुलांनी भक्त पुंडलिकावर विशेष कार्यक्रम सादर केला</li>
        </ul>

        <h4>🎯 माननीय डॉ. नितीनभाऊंचा संदेश:</h4>
        <p>माननीय डॉ. नितीनभाऊंनी प्रेरणादायी प्रवचनात सांगितले की सेवा आणि संस्कार हे पूजेचे सर्वात शुद्ध स्वरूप आहेत. त्यांनी पालक आणि युवकांना व्यावहारिक मार्गदर्शन दिले. त्यांच्या संदेशाने सर्व उपस्थितांना खूप प्रेरणा मिळाली.</p>

        <p>भक्तांना २०२६ चे कॅलेंडर आणि विशेष आशीर्वाद किट देण्यात आली. बालसंस्कार मुलांनी प्रेरणादायी सांस्कृतिक कार्यक्रम सादर केले, ज्यात भक्त पुंडलिकावरील विशेष कार्यक्रम होता, जो श्री गुरुपीठच्या मूल्य-आधारित शिक्षणाच्या ध्येयाचे प्रतिबिंब होता.</p>
      `,
      venue: {
        name: "अटलांटा",
        address: "अटलांटा, जॉर्जिया, USA",
        mapLink: "https://maps.google.com/?q=Atlanta+Georgia"
      },
      highlights: [
        "USA च्या १० राज्यांतील भक्तांची उपस्थिती",
        "सेवा आणि संस्कार - पूजेचा सर्वोत्तम प्रकार",
        "बालसंस्कार - भक्त पुंडलिक कार्यक्रम",
        "करिअर मार्गदर्शन आणि युवा उपक्रम",
        "२०२६ कॅलेंडर आणि आशीर्वाद किट वाटप"
      ],
      timings: "संपूर्ण दिवस",
      location: "अटलांटा, जॉर्जिया"
    },
    {
      id: 10,
      title: "विश्वशांती महोत्सव २०२५: ब्रॅम्पटन, कॅनडा",
      subtitle: "USA ते कॅनडा - आध्यात्मिक सौहार्दाची एकसंध लाट",
      date: "१६ नोव्हेंबर २०२५",
      endDate: "2025-11-16",
      thumbnail: vishwashantiBrampton,
      photos: [vishwashantiBrampton],
      videos: [],
      description: "USA मधील विश्वशांती महोत्सवाच्या यशस्वी उत्सवानंतर, सेवा, संस्कार आणि शांतीची आध्यात्मिक लाट ब्रॅम्पटन, कॅनडा येथे पोहोचली, जिथे १६ नोव्हेंबर २०२५ रोजी भक्ती आणि उत्साहाने विश्वशांती महोत्सव साजरा करण्यात आला.",
      fullContent: `
        <h3>🙏 USA ते कॅनडा - आध्यात्मिक सौहार्दाची एकसंध लाट</h3>
        <h4>विश्वशांती महोत्सव २०२५: ब्रॅम्पटन, कॅनडा</h4>

        <p>USA मधील विश्वशांती महोत्सवाच्या यशस्वी उत्सवानंतर, सेवा, संस्कार आणि शांतीची आध्यात्मिक लाट ब्रॅम्पटन, कॅनडा येथे पोहोचली, जिथे १६ नोव्हेंबर २०२५ रोजी भक्ती आणि उत्साहाने विश्वशांती महोत्सव साजरा करण्यात आला.</p>

        <h4>✨ कार्यक्रमाची वैशिष्ट्ये:</h4>
        <ul>
          <li>माननीय डॉ. नितीनभाऊंनी भक्तांना अध्यात्म आणि अंतर्गत शांतीबद्दल मार्गदर्शन केले</li>
          <li>कुटुंब आणि समुदाय मूल्ये मजबूत करण्यासाठी व्यावहारिक अंतर्दृष्टी</li>
          <li>पादुका पूजन, सांस्कृतिक सादरीकरण आणि विश्वशांती प्रार्थना</li>
          <li>एकता आणि शांतीचे वातावरण निर्माण</li>
        </ul>

        <h4>🌟 मान्यवर उपस्थिती:</h4>
        <ul>
          <li>श्री. मुरारीलाल थापलियाल (अध्यक्ष आणि संस्थापक-अध्यक्ष, सनातन बोर्ड कॅनडा)</li>
          <li>श्री. दीपक मलिक (अध्यक्ष आणि नवनिर्वाचित बोर्ड संचालक, इंडो-कॅनडा चेंबर ऑफ कॉमर्स)</li>
        </ul>

        <h4>🎨 सांस्कृतिक कार्यक्रम:</h4>
        <p>मातृ-पितृ पूजन, श्री चक्रराज श्रीयंत्र पूजन, बालसंस्कार सादरीकरण आणि भक्तिमय उपक्रमांनी श्री गुरुपीठचे सेवा, संस्कार आणि शांती पसरवण्याचे ध्येय सुंदरपणे प्रतिबिंबित केले.</p>

        <p>महोत्सवाचा समारोप जागतिक सौहार्दासाठी सामूहिक प्रार्थनेने झाला आणि भक्तांना २०२६ चे कॅलेंडर आणि विशेष आशीर्वाद किट मिळाली.</p>
      `,
      venue: {
        name: "ब्रॅम्पटन",
        address: "ब्रॅम्पटन, ओंटारियो, कॅनडा",
        mapLink: "https://maps.google.com/?q=Brampton+Ontario+Canada"
      },
      highlights: [
        "USA ते कॅनडा - आध्यात्मिक लाट",
        "माननीय डॉ. नितीनभाऊंचे मार्गदर्शन",
        "सनातन बोर्ड कॅनडा व इंडो-कॅनडा चेंबरचे प्रतिनिधी",
        "मातृ-पितृ पूजन व बालसंस्कार",
        "जागतिक सौहार्दासाठी सामूहिक प्रार्थना"
      ],
      timings: "संपूर्ण दिवस",
      location: "ब्रॅम्पटन, कॅनडा"
    },
    {
  id: 11,
  title: "विश्वशांती महोत्सव २०२५: न्यूकॅसल, UK",
  subtitle: "सेवा आणि शांतीचा संदेश UK मध्ये",
  date: "१८ नोव्हेंबर २०२५",
  endDate: "2025-11-18",
  thumbnail: vishwashantiNewcastle,
  photos: [vishwashantiNewcastle],
  videos: [],
  description: "न्यूकॅसल, UK येथे माननीय डॉ. नितीनभाऊ आणि श्री स्वामी समर्थ सेवा मार्गाचे हार्दिक स्वागत करण्यात आले, जिथे विश्वशांती महोत्सव २०२५ अपार भक्ती आणि उत्साहाने साजरा करण्यात आला.",
  fullContent: `
    <h3>🙏 स्वामींचा सेवा आणि शांतीचा संदेश UK मध्ये</h3>
    <h4>विश्वशांती महोत्सव - न्यूकॅसल, UK - २०२५</h4>

    <p>न्यूकॅसल, UK येथे माननीय डॉ. नितीनभाऊ आणि श्री स्वामी समर्थ सेवा मार्गाचे हार्दिक स्वागत करण्यात आले, जिथे विश्वशांती महोत्सव २०२५ अपार भक्ती आणि उत्साहाने साजरा करण्यात आला.</p>

    <h4>✨ माननीय डॉ. नितीनभाऊंचे प्रेरणादायी प्रवचन:</h4>
    <p>माननीय डॉ. नितीनभाऊंनी प्रेरणादायी प्रवचनात शांती, अंतर्बळ आणि मजबूत कुटुंबे व समुदाय निर्माण करण्यासाठी सेवा व संस्कारांचे महत्त्व यावर भर दिला.</p>

    <h4>🌺 कार्यक्रमाची रूपरेषा:</h4>
    <ul>
      <li>हार्दिक स्वागत आणि आगमन सोहळा</li>
      <li>बालसंस्कार आणि मुलांचे सांस्कृतिक कार्यक्रम</li>
      <li>पालखी सेवा</li>
      <li>आर्थिक समृद्धीसाठी पवित्र श्री चक्रराज श्रीयंत्र पूजन</li>
      <li>माननीय डॉ. नितीनभाऊंसोबत वन-टू-वन मार्गदर्शन (प्रश्नोत्तर) सत्रे</li>
      <li>महाप्रसाद</li>
    </ul>

    <h4>🎯 विशेष आकर्षण:</h4>
    <p>माननीय डॉ. नितीनभाऊंसोबत वैयक्तिक मार्गदर्शन (प्रश्नोत्तर) सत्रांना प्रचंड प्रतिसाद मिळाला आणि अनेक आध्यात्मिक व वैयक्तिक प्रश्नांवर स्पष्टता मिळाली.</p>

    <p>महोत्सवाचा समारोप महाप्रसादाने झाला आणि भक्त शांती, कृतज्ञता आणि विश्वशांतीच्या दिव्य संदेशाने भरून गेले.</p>
  `,
  venue: {
    name: "न्यूकॅसल",
    address: "न्यूकॅसल, युनायटेड किंगडम",
    mapLink: "https://maps.google.com/?q=Newcastle+United+Kingdom"
  },
  highlights: [
    "माननीय डॉ. नितीनभाऊंचे प्रेरणादायी प्रवचन",
    "बालसंस्कार आणि मुलांचे कार्यक्रम",
    "श्री चक्रराज श्रीयंत्र पूजन",
    "वन-टू-वन मार्गदर्शन सत्रे (प्रश्नोत्तर)",
    "सेवा आणि शांतीचा संदेश UK मध्ये"
  ],
  timings: "संपूर्ण दिवस",
  location: "न्यूकॅसल, UK"
},
{
  id: 12,
  title: "श्री दत्त जयंती निमित्त अखंड-नाम-जप-यज्ञ सप्ताह",
  subtitle: "श्री गुरुपीठ त्र्यंबकेश्वर आणि पवित्र क्षेत्रांमध्ये",
  date: "२८ नोव्हेंबर २०२५",
  endDate: "2025-12-05",
  thumbnail: dattaJayantiAkhandJap,
  photos: [dattaJayantiAkhandJap],
  videos: [],
  description: "परमपूज्य गुरुमाऊलींच्या कृपाआशीर्वादाने श्री गुरुपीठ त्र्यंबकेश्वर, श्री क्षेत्र नृसिंहवाडी, श्री क्षेत्र गाणगापूर, श्री क्षेत्र पिठापूर येथे दिनांक २८/११/२०२५ ते ५/१२/२०२५ या कालावधीत श्री दत्त जयंती निमित्त अखंड नाम जप यज्ञ सप्ताह होत आहे.",
  fullContent: `
    <h3>!! श्री स्वामी समर्थ !!</h3>
    <h4>श्री दत्त जयंती निमित्त अखंड नामजप यज्ञ सप्ताह</h4>

    <p>परमपूज्य गुरुमाऊलींच्या कृपाआशीर्वादाने खालील पवित्र क्षेत्रांमध्ये श्री दत्त जयंती निमित्त अखंड नाम जप यज्ञ सप्ताह आयोजित करण्यात येत आहे:</p>

    <h4>📍 स्थळे:</h4>
    <ul>
      <li>श्री गुरुपीठ त्र्यंबकेश्वर</li>
      <li>श्री क्षेत्र नृसिंहवाडी</li>
      <li>श्री क्षेत्र गाणगापूर</li>
      <li>श्री क्षेत्र पिठापूर</li>
    </ul>

    <h4>📅 कालावधी:</h4>
    <p><strong>२८ नोव्हेंबर २०२५ ते ५ डिसेंबर २०२५</strong></p>

    <h4>🙏 सहभाग कसा घ्यावा:</h4>
    <p>ज्या भाविकांना या पवित्र सेवेत सहभाग घ्यायचा आहे त्यांनी खालील लिंक वर नाव नोंदणी करावी आणि या सुवर्णसंधीचा लाभ घ्यावा.</p>

    <h4>📞 संपर्क:</h4>
    <ul>
      <li>१. श्री गुरुपीठ त्र्यंबकेश्वर - ८२६३९१९२००</li>
      <li>२. श्री क्षेत्र नृसिंहवाडी - ९२२६५३८४२७</li>
      <li>३. श्री क्षेत्र गाणगापूर - ९२२६५३८४२८ / ९२२६५३८४२६</li>
      <li>४. श्री क्षेत्र पिठापूर - ७४४७४३६०२१ / ९०२२०६१६९९</li>
    </ul>

    <h4>📝 नाव नोंदणी:</h4>
    <p>खालील लिंक वर नाव नोंदणी करावी:<br>
    <a href="https://surveyheart.com/form/691c2ed003886962932dc7d0" target="_blank">https://surveyheart.com/form/691c2ed003886962932dc7d0</a></p>

    <h4>✨ अखंड नामजप यज्ञाचे महत्त्व:</h4>
    <p>श्री दत्त जयंती निमित्त होणारा हा अखंड नामजप यज्ञ अत्यंत पुण्यदायी आणि फलदायी आहे. या पवित्र सेवेत सहभागी होऊन भगवान दत्तात्रेयांचे आशीर्वाद प्राप्त करा.</p>
  `,
  registerlink : 'https://surveyheart.com/form/691c2ed003886962932dc7d0',
  venue: {
    name: "चार पवित्र क्षेत्रे",
    address: "श्री गुरुपीठ त्र्यंबकेश्वर, नृसिंहवाडी, गाणगापूर, पिठापूर",
    mapLink: "https://maps.app.goo.gl/HG5qHR3WwQLivnpT8"
  },
  highlights: [
    "परमपूज्य गुरुमाऊलींच्या आशीर्वादाने",
    "चार पवित्र क्षेत्रांमध्ये एकाचवेळी",
    "२८ नोव्हेंबर ते ५ डिसेंबर - ८ दिवसीय यज्ञ",
    "ऑनलाईन नाव नोंदणी सुविधा",
    "श्री दत्त जयंती विशेष"
  ],
  timings: "२८ नोव्हेंबर २०२५ ते ५ डिसेंबर २०२५",
  location: "त्र्यंबकेश्वर, नृसिंहवाडी, गाणगापूर, पिठापूर"
},
 {
      id: 13,
      title: "श्री क्षेत्र पिठापूर - एकदिवसीय हवन युक्त श्री गुरुचरित्र पारायण व श्री सिद्धमंगल पादुका पूजन",
      subtitle: "श्री अनघाष्टमी निमित्त विशेष पूजन",
      date: "११ डिसेंबर २०२५",
      endDate: "2025-12-11",
      thumbnail: pithapurPadukaPujan,
      photos: [pithapurPadukaPujan],
      videos: [],
      description: "परमपूज्य गुरुमाऊलींच्या कृपाआशीर्वादाने व आदरणीय श्री दादासाहेबांच्या प्रमुख उपस्थितीत श्री क्षेत्र पिठापूर (आंध्र प्रदेश) येथे श्री अनघाष्टमी निमित्त एकदिवसीय हवन युक्त श्री गुरुचरित्र पारायण आणि श्री सिद्धमंगल पादुका पूजन आयोजित करण्यात येत आहे.",
      fullContent: `
        <h3>‼️ श्री स्वामी समर्थ ‼️</h3>
        <h4>अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ, त्र्यंबकेश्वर, जि. नाशिक</h4>

        <p>परमपूज्य गुरुमाऊलींच्या कृपा आशीर्वादाने आणि आदरणीय श्री दादासाहेब यांच्या प्रमुख उपस्थितीत गुरुवार <strong>दिनांक ११ डिसेंबर २०२५</strong> रोजी <strong>श्री क्षेत्र पिठापूर, आंध्र प्रदेश</strong> येथे <strong>एकदिवसीय हवन युक्त श्री गुरुचरित्र पारायण आणि श्री सिद्धमंगल पादुका पूजन</strong> आयोजीत करण्यात आले आहे.</p>

        <p>परब्रम्ह श्रीपाद प्रभु यांच्या जन्मस्थळी श्री क्षेत्र पिठापूर येथे श्री अनघाष्टमी या पावन पर्वावर विवाह, नोकरी, आरोग्य, शिक्षण तसेच अनेक असाध्य समस्या निवारण होण्याकरिता या पूजनात अवश्य सहभागी व्हावे. या पूजनात श्रींच्या पादुका मस्तकावर ठेवल्या जातात, ज्यामुळे नकारात्मक ऊर्जा दूर होतात व सर्व प्रकारचे दोष-अडचणींचे निवारण होते.</p>

        <h4>📌 देवदुर्लभ संधी, सर्वांनी लाभ घ्यावा!</h4>

        <p><strong>नोंदणी लिंक:</strong><br>
        <a href="https://surveyheart.com/form/6922da15566e2c0e996f8f99" target="_blank">https://surveyheart.com/form/6922da15566e2c0e996f8f99</a></p>

        <p>या दुर्मिळ व पुण्यदायी पूजनात सहभागी होऊन श्री स्वामी समर्थ महाराज व श्रीपाद श्रीवल्लभांचे कृपाशीर्वाद प्राप्त करावेत, ही नम्र विनंती.</p>
      `,
      registerlink : 'https://surveyheart.com/form/6922da15566e2c0e996f8f99',
      venue: {
        name: "श्री क्षेत्र पिठापूरम",
        address: "पिठापूरम, आंध्र प्रदेश",
        mapLink: "https://maps.app.goo.gl/DWMiMJ3TXyzEZBdZ9"   // ← Update with actual map link if available
      },
      highlights: [
        "श्री अनघाष्टमी निमित्त विशेष पूजन",
        "हवन युक्त श्री गुरुचरित्र पारायण",
        "श्री सिद्धमंगल पादुका पूजन",
        "विवाह, नोकरी, आरोग्य, शिक्षण व असाध्य समस्यांवर उपाय",
        "परब्रम्ह श्रीपाद श्रीवल्लभ जन्मस्थळी आयोजन"
      ],
      timings: "११ डिसेंबर २०२५ (संपूर्ण दिवस)",
      location: "श्री क्षेत्र पिठापूरम, आंध्र प्रदेश",
      registerLink: "https://surveyheart.com/form/6922da15566e2c0e996f8f99"
    },
    {
  id: 14,
  title: "श्री क्षेत्र गाणगापूर - एकदिवसीय हवनयुक्त श्री गुरूचरित्र पारायण व श्री अनघा दत्त सिद्धपादुका पूजन सोहळा",
  subtitle: "श्री गुरुप्रतिपदा (शैल्यगमन) निमित्त विशेष",
  date: "२ फेब्रुवारी २०२६",
  endDate: "2026-02-02",
  thumbnail: GurucharitaGangapurImage,
  photos: [GurucharitaGangapurImage],
  videos: [],
  description: "अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ, त्र्यंबकेश्वर, नाशिक यांच्या वतीने श्री गुरुप्रतिपदा (शैल्यगमन) निमित्त दत्तधाम, श्री क्षेत्र गाणगापूर, कर्नाटक येथे एकदिवसीय हवनयुक्त श्री गुरूचरित्र पारायण व श्री अनघा दत्त सिद्धपादुका पूजन सोहळा आयोजित करण्यात येत आहे.",
  fullContent: `
    <h3>‼️ श्री स्वामी समर्थ ‼️</h3>
    <h4>अखिल भारतीय श्री स्वामी समर्थ गुरुपीठ, त्र्यंबकेश्वर, नाशिक</h4>
    <h4>श्री गुरुप्रतिपदा (शैल्यगमन) निमित्त विशेष</h4>

    <p><strong>📅 दिनांक: २ फेब्रुवारी २०२६</strong></p>

    <h3>🔥 कार्यक्रम तपशील:</h3>
    <ul>
      <li>एक दिवसीय हवनयुक्त श्री गुरूचरित्र पारायण</li>
      <li>🙏 श्री अनघा दत्त सिद्धपादुका पूजन सोहळा (श्री सिद्धमंगल पादुका पूजन)</li>
    </ul>

    <h3>📍 स्थळ:</h3>
    <p>दत्तधाम, श्री क्षेत्र गाणगापूर, कर्नाटक</p>

    <h3>📦 सोबत आणावयाचे साहित्य:</h3>
    <ul>
      <li>श्री गुरुचरित्र ग्रंथ</li>
      <li>जपमाळ</li>
      <li>आसन</li>
      <li>नित्यसेवा</li>
    </ul>

    <h3>📞 अधिक माहितीसाठी संपर्क:</h3>
    <p>7020478721 | 7796926111</p>

    <h4>📌 विशेष सूचना:</h4>
    <p>१८ विभाग प्रतिनिधींनी सेवेचा अधिकाधिक प्रचार-प्रसार करावा, व मोठ्या प्रमाणात भाविक सेवेकऱ्यांनी या सेवेचा लाभ घ्यावा.</p>

    <p><strong>नाव नोंदणी:</strong><br>
    <a href="https://form.svhrt.com/6922da15566e2c0e996f8f99" target="_blank">https://form.svhrt.com/6922da15566e2c0e996f8f99</a></p>

    <h4>🙏 देवदुर्लभ संधी, सर्वांनी लाभ घ्यावा!</h4>
  `,
  registerlink: 'https://form.svhrt.com/6922da15566e2c0e996f8f99',
  venue: {
    name: "दत्तधाम, श्री क्षेत्र गाणगापूर",
    address: "गाणगापूर, कर्नाटक",
    mapLink: "https://maps.app.goo.gl/4dG8cvMgyPHFLMLz8"  // Add Google Maps link if available
  },
  highlights: [
    "श्री गुरुप्रतिपदा (शैल्यगमन) निमित्त विशेष पूजन",
    "एक दिवसीय हवनयुक्त श्री गुरूचरित्र पारायण",
    "श्री अनघा दत्त सिद्धपादुका पूजन सोहळा",
    "श्री सिद्धमंगल पादुका पूजन",
    "दत्तधाम, श्री क्षेत्र गाणगापूर येथे आयोजन"
  ],
  timings: "२ फेब्रुवारी २०२६ (संपूर्ण दिवस)",
  location: "दत्तधाम, श्री क्षेत्र गाणगापूर, कर्नाटक",
  registerLink: "https://form.svhrt.com/6922da15566e2c0e996f8f99",
  contactNumbers: ["7020478721", "7796926111"],
  itemsToBring: [
    "श्री गुरुचरित्र ग्रंथ",
    "जपमाळ",
    "आसन",
    "नित्यसेवा"
  ]
}

  ],
  en: [
    {
      id: 1,
      title: "Shree Ghor Kashtodwarak Pujan",
      subtitle: "Special Spiritual Ceremony",
      date: "October 24–26, 2025",
      endDate: "2025-10-26",
      thumbnail: ShreeGhorKashtodwarakPujan,
      photos: [ShreeGhorKashtodwarakPujan, gangapurEvent],
      videos: [
        {
          title: "Ghor Kashtodwarak Pujan",
          url: "https://www.youtube.com/embed/EH8bHnCeXnM?si=NdfXGm2VN15R46jn"
        }
      ],
      description: "The Shree Ghor Kashtodwarak Pujan is a powerful ritual that helps devotees overcome mental, physical, and financial difficulties through divine grace.",
      fullContent: `
        <h3>🙏 Shree Ghor Kashtodwarak Pujan</h3>
        <p>This special pujan is performed to remove severe life obstacles, relieve stress and suffering, and attract divine blessings for overall well-being.</p>

        <h4>✨ Benefits:</h4>
        <ul>
          <li>Relief from physical and mental distress</li>
          <li>Freedom from financial and family problems</li>
          <li>Success and peace in business, job, and health matters</li>
        </ul>

        <h4>📅 Dates:</h4>
        <p>October 24–26, 2025</p>

        <h4>📍 Venue:</h4>
        <p><strong>Akhil Bharatiya Shree Swami Samarth Gurupeeth Branch</strong><br>Ganagapur, Karnataka</p>

        <h4>📞 Contact:</h4>
        <p>8956630913 / 8956630914 / 8956630915 / 7709107339 / 9970447132</p>
      `,
      venue: {
        name: "Akhil Bharatiya Shree Swami Samarth Gurupeeth Branch",
        address: "Ganagapur, Karnataka",
        mapLink: "https://maps.app.goo.gl/yrvTaTonq7BCPkrs6"
      },
      highlights: [
        "Freedom from mental, physical, and financial suffering",
        "Solutions for major life problems",
        "Divine blessings from Gurupeeth"
      ],
      timings: "October 24–26, 2025",
      location: "Ganagapur, Karnataka"
    },
    {
      id: 2,
      title: "Global Agricultural Festival 2026",
      subtitle: "Celebrating Organic & Natural Farming",
      date: "January 23-27, 2026",
      endDate: "2026-01-27",
      thumbnail: JKMKrushi,
      photos: [JKMKrushi, AgricultureFestival, AgricultureFestival1],
      videos: [
        {
          title: "Krushi Mahotsav 2024 Highlights",
          url: "https://www.youtube.com/embed/dohcsIlAbrk"
        },
        {
          title: "Organic Farming Techniques",
          url: "https://www.youtube.com/embed/_Y7Icpgqcbc"
        }
      ],
      description: "Krushi Mahotsav is an international agricultural festival organized in Nashik under the Shri Swami Samarth Seva Marg, Dindori. This festival promotes organic farming, sustainable agriculture, and traditional farming methods.",
      fullContent: `
        <h3>🌾 Global Agricultural Festival 2026</h3>
        <p>Krushi Mahotsav is an international agricultural festival organized in Nashik under the Shri Swami Samarth Seva Marg, Dindori.</p>
        
        <h4>✨ Highlights:</h4>
        <ul>
          <li>International farmers' exhibition</li>
          <li>Organic farming workshops and demonstrations</li>
          <li>Agricultural equipment showcase</li>
          <li>Traditional seed preservation center</li>
          <li>Livestock and dairy farming guidance</li>
          <li>Free soil testing camp</li>
          <li>Awards for progressive farmers</li>
        </ul>

        <h4>📍 Venue:</h4>
        <p><strong>Agriculture Exhibition Ground, Nashik</strong><br>
        Krushi Mahotsav Grounds, Dindori Road, Nashik, Maharashtra 422202</p>

        <h4>🕐 Timings:</h4>
        <p>8:00 AM - 8:00 PM (All 5 days)</p>

        <h4>🌐 More Information:</h4>
        <p><a href="https://www.krushimahotsav.org/" target="_blank">www.krushimahotsav.org</a></p>
      `,
      venue: {
        name: "Agriculture Exhibition Ground, Nashik",
        address: "Krushi Mahotsav Grounds, Dindori Road, Nashik, Maharashtra 422202",
        mapLink: "https://www.krushimahotsav.org/"
      },
      highlights: [
        "International farmers' exhibition",
        "Organic farming workshops and demonstrations",
        "Agricultural equipment showcase",
        "Traditional seed preservation center",
        "Livestock and dairy farming guidance",
        "Free soil testing camp",
        "Awards for progressive farmers"
      ],
      timings: "8:00 AM - 8:00 PM (All 5 days)",
      location: "Nashik, Maharashtra"
    },
    {
      id: 3,
      title: "Skill Training Drive",
      subtitle: "Self-employment & Vocational Workshops",
      date: "November 02, 2025",
      endDate: "2025-11-02",
      thumbnail: Swayamrojgar,
      photos: [Swayamrojgar, SkillDevepImage2, SkillDevepImage],
      videos: [
        {
          title: "Success Stories",
          url: "https://www.youtube.com/embed/6JSiEUtimkk?si=wpGVoG8ydYtW1CUS"
        }
      ],
      description: "A comprehensive skill development program aimed at empowering youth and women with vocational training, entrepreneurship guidance, and self-employment opportunities.",
      fullContent: `
        <h3>💼 Skill Training Drive</h3>
        <p>A comprehensive skill development program aimed at empowering youth and women with vocational training, entrepreneurship guidance, and self-employment opportunities.</p>
        
        <h4>✨ Highlights:</h4>
        <ul>
          <li>Tailoring and garment making</li>
          <li>Computer training and digital literacy</li>
          <li>Food processing and packaging</li>
          <li>Beauty and wellness courses</li>
          <li>Small business management</li>
          <li>Free certification on completion</li>
          <li>Placement assistance</li>
        </ul>

        <h4>📍 Venue:</h4>
        <p><strong>Seva Marg Training Center, Dindori</strong><br>
        Shree Gurupeeth Campus, Dindori, Nashik, Maharashtra 422202</p>

        <h4>🕐 Timings:</h4>
        <p>9:00 AM - 5:00 PM (6 days program)</p>
      `,
      venue: {
        name: "Seva Marg Training Center, Dindori",
        address: "Shree Gurupeeth Campus, Dindori, Nashik, Maharashtra 422202",
        mapLink: "https://maps.app.goo.gl/WhNPhR37o5iTJv558"
      },
      highlights: [
        "Tailoring and garment making",
        "Computer training and digital literacy",
        "Food processing and packaging",
        "Beauty and wellness courses",
        "Small business management",
        "Free certification on completion",
        "Placement assistance"
      ],
      timings: "9:00 AM - 5:00 PM (6 days program)",
      location: "Dindori, Nashik"
    },
    {
      id: 4,
      title: "Mahakal AshtaBhairav Pujan & Mahakali Yag",
      subtitle: "Special Spiritual Ceremony",
      date: "November 12, 2025",
      endDate: "2025-11-12",
      thumbnail: MahakalAshtaBhairavPujan,
      photos: [MahakalAshtaBhairavPujan],
      videos: [],
      description:
        "A sacred ceremony organized at Akhil Bharatiya Shree Swami Samarth Gurupeeth, Trimbakeshwar, dedicated to national welfare and the protection of all beings through the divine Mahakal AshtaBhairav Pujan and Mahakali Yag.",
      fullContent: `
        <h3>!! Shree Swami Samarth !!</h3>
        <h4>Akhil Bharatiya Shree Swami Samarth Gurupeeth, Trimbakeshwar</h4>

        <h3>🙏 Mahakal AshtaBhairav Pujan & Mahakali Yag 🙏</h3>
        <p>🗓 Date: November 12, 2025</p>
        <p>📍 Venue: Akhil Bharatiya Shree Swami Samarth Gurupeeth, Trimbakeshwar</p>

        <h4>🌺 Program Schedule:</h4>
        <ul>
          <li>🕙 10:00 AM – 10:25 AM – Volunteer Meeting & Planning</li>
          <li>🕥 10:30 AM – Naivedya Aarti</li>
          <li>🕥 10:40 AM – 3:00 PM – Mahasankalp for National Welfare & Global Well-being</li>
          <li>* AshtaBhairav Mantra & MahakalBhairav Ashtak Havan</li>
          <li>* Mahakali Yag (Sanskrit Durga Saptashati Chanting)</li>
          <li>* Divine Discourse by Chandrakant Dadasaheb</li>
          <li>🕥 4:00 PM – 5:00 PM – Collective Bhairav Pujan and Conclusion</li>
        </ul>

        <p>Register for this special pujan using the Google Form: 
        <a href="https://tinyurl.com/MahakalashtBhairavPujan" target="_blank">https://tinyurl.com/MahakalashtBhairavPujan</a></p>

        <h4>🪔 Items to Bring:</h4>
        <p>Plate, spoon-cup set, Bhairav idol (or Shivling), turmeric, kumkum, ashtagandha, akshata, rock sugar, cloth for idol, water bottle, napkin, Nityaseva book, Sanskrit Durga Saptashati, japmala, one coconut, etc.</p>
      `,
      venue: {
        name: "Akhil Bharatiya Shree Swami Samarth Gurupeeth",
        address: "Trimbakeshwar, Nashik, Maharashtra",
        mapLink: "https://maps.app.goo.gl/HG5qHR3WwQLivnpT8"
      },
      highlights: [
        "Mahakal AshtaBhairav Pujan and Mahakali Yag",
        "Dedicated to national welfare and world peace",
        "Chanting of Sanskrit Durga Saptashati with sacred fire rituals"
      ],
      timings: "10:00 AM - 5:00 PM",
      location: "Trimbakeshwar, Nashik"
    },
    {
      id: 5,
      title: "Vishwashanti Mahotsav 2025: Los Angeles",
      subtitle: "A Joyous Celebration of World Peace",
      date: "November 08, 2025",
      endDate: "2025-11-08",
      thumbnail: vishwashantiLA,
      photos: [vishwashantiLA],
      videos: [],
      description: "Joyously celebrated in Los Angeles, CA, the event featured Maha Aarti, Swami Paduka Darshan, a vibrant Palkhi procession, and heartwarming Bal Sanskar activities, graced by distinguished community leaders.",
      fullContent: `
        <h3>🙏 Vishwashanti Mahotsav 2025: Los Angeles, California</h3>
        <p>The Vishwashanti Mahotsav 2025 (USA) was joyously celebrated in Los Angeles, California. Swami devotees from across the state extended a warm and heartfelt welcome to Hon. Nitinbhau and Shree Swami Samarth Seva Marg.</p>

        <h4>✨ Event Highlights:</h4>
        <ul>
          <li>Maha Aarti, Swami Paduka Darshan, and a joyous Swami Palkhi procession.</li>
          <li>Auspicious Shri Yantra Poojan and Maha Prasad (Annadan).</li>
          <li>Vibrant traditional dance with participation from all devotees.</li>
          <li>Devotees shared testimonials of how challenges were resolved after receiving Spiritual Guidance from the previous year's event.</li>
        </ul>
        
        <h4>👨‍👩‍👧‍👦 Bal Sanskar Activities:</h4>
        <p>The Bal Sanskar activities—including skits, presentations, and the “Inner Peace to World Peace” competition—received an overwhelming response. The Bal Sanskar Sevekaris were awarded certificates by Hon. Nitinbhau for their outstanding performance.</p>

        <h4>🌟 Distinguished Guests:</h4>
        <p>The Mahotsav was graced by Mrs. Aparna Hande Ji (President, SMAP-LA), Mr. Kewal Kanda (Chair, United Indian Associations), Dr. Shrikrishna Vaidya (Neurologist), and other eminent personalities.</p>
      `,
      venue: {
        name: "Los Angeles",
        address: "Los Angeles, California, USA",
        mapLink: "https://maps.google.com/?q=Los+Angeles+California"
      },
      highlights: [
        "Maha Aarti & Swami Paduka Darshan",
        "Bal Sanskar skits and competitions",
        "Presence of distinguished community leaders",
        "Spiritual Guidance success stories"
      ],
      timings: "Full Day Event",
      location: "Los Angeles, California"
    },
    {
      id: 6,
      title: "Vishwashanti Mahotsav 2025: Bay Area",
      subtitle: "Spreading the Message of Seva, Sanskar, and Shanti",
      date: "November 09, 2025",
      endDate: "2025-11-09",
      thumbnail: vishwashantiBayArea,
      photos: [vishwashantiBayArea],
      videos: [],
      description: "Celebrated in the Bay Area with divine blessings, this Mahotsav focused on Seva, Sanskar, and Shanti, featuring youth-led initiatives, cultural activities, and profound spiritual guidance from Aadarniya Nitinbhau.",
      fullContent: `
        <h3>🙏 Vishwashanti Mahotsav 2025: Bay Area, California</h3>
        <p>With the divine blessings of His Holiness Gurumauli, the Vishwashanti Mahotsav 2025 was joyously celebrated by Shree Swami Samarth Gurupeeth, USA in the Bay Area, California. Devotees gathered with deep devotion to spread Swami Maharaj’s message of Seva, Sanskar, and Shanti.</p>
        
        <h4>✨ Main Attractions:</h4>
        <ul>
          <li>Auspicious Chakraraj Shree Yantra Poojan and Shree Swami Samarth Maharaj Paduka Abhishek.</li>
          <li>Aadarniya Nitinbhau’s inspiring Hitaguj, offering profound spiritual guidance.</li>
          <li>A captivating Gurupranali and Gurupeeth Karya skit performed by children.</li>
          <li>Vishwa Shanti Prarthana, Maha Aarti, and a joyous Palakhi Seva.</li>
          <li>Youth-led Winter Clothes Donation Drive.</li>
        </ul>

        <h4>🎨 Bal Sanskar & Youth Wing:</h4>
        <ul>
          <li>Creative seva: Making greeting cards and bookmarks for senior citizens.</li>
          <li>Saraswati Poojan and Matru-Pitru Poojan to nurture cultural values.</li>
          <li>'Assistive Technology Competition' for social good.</li>
        </ul>

        <p>A special highlight was Aadarniya Nitinbhau’s inspiring Hitaguj, which enriched devotees’ understanding of His Holiness Gurumauli’s social mission and Shree Gurupeeth’s divine path of selfless seva.</p>
      `,
      venue: {
        name: "Bay Area",
        address: "Bay Area, California, USA",
        mapLink: "https://maps.google.com/?q=Bay+Area+California"
      },
      highlights: [
        "Chakraraj Shree Yantra Poojan",
        "Youth-led Winter Clothes Donation Drive",
        "Assistive Technology Competition",
        "Inspiring Hitaguj by Aadarniya Nitinbhau",
        "Matru-Pitru Poojan & Bal Sanskar"
      ],
      timings: "Full Day Event",
      location: "Bay Area, California"
    },
    {
  id: 7,
  title: "Vishwashanti Mahotsav 2025: Seattle",
  subtitle: "Spreading the Message of Spiritual Peace",
  date: "November 07, 2025",
  endDate: "2025-11-07",
  thumbnail: vishwashantiSeattle,
  photos: [vishwashantiSeattle],
  videos: [],
  description: "With the divine blessings of Shree Swami Samarth Maharaj and His Holiness Gurumauli, the Seattle Vishwa Shanti Mahotsav was celebrated with great devotion and joy, attended by around 150 devotees.",
  fullContent: `
    <h3>🌍 Vishwa Shanti Mahotsav – Seattle 🌍</h3>
    <p>With the divine blessings of Shree Swami Samarth Maharaj and His Holiness Gurumauli, the Seattle Vishwa Shanti Mahotsav was celebrated with great devotion and joy, attended by around 150 devotees.</p>

    <h4>✨ Event Highlights:</h4>
    <ul>
      <li>Program commenced at 5 PM with Laxmi Prapti Seva</li>
      <li>Aagman, Aukshan, Deep Prajwalan, and Satkar of Hon. Nitin More (Bhau)</li>
      <li>Beautiful Balsanskar performance by 12 children depicting "World Peace rests on three pillars – peace with myself, peace with others, and peace in unity"</li>
      <li>Informative presentations about Shree Swami Samarth Maharaj and His Holiness Gurumauli</li>
      <li>Aarti, introduction of Hon. Nitin Bhau and Hitguj (spiritual discourse)</li>
      <li>Felicitation of Chief Guest Mr. Vamshi Reddy, President of TTA and founder of multiple non-profit organizations</li>
      <li>Darshan Sohla, Palakhi procession, and 1:1 guidance sessions</li>
    </ul>

    <h4>🙏 Social Initiative:</h4>
    <p>A noble Food Drive was organized, collecting canned and non-perishable foods to support the needy.</p>

    <h4>🌟 Special Guest:</h4>
    <p>The event was graced by Entrepreneur and devoted Sai Bhakta – Shri Vamshi Reddy Ji.</p>

    <p>The sacred Shree Swami Samarth Paduka Poojan, the devotional Palakhi Sohala, inspiring presentations by the Bal Sanskar Cell children, and spiritual guidance filled every heart with devotion, joy, and peace. The atmosphere was filled with devotion, positivity, and joy—everyone left with hearts full of peace and happiness.</p>
  `,
  venue: {
    name: "Seattle",
    address: "Seattle, Washington, USA",
    mapLink: "https://maps.google.com/?q=Seattle+Washington"
  },
  highlights: [
    "Sacred Shree Swami Samarth Paduka Poojan",
    "Inspiring Bal Sanskar performance by children",
    "Food Drive for the needy",
    "Presence of Chief Guest Shri Vamshi Reddy",
    "Devotional atmosphere with personal guidance"
  ],
  timings: "5:00 PM onwards",
  location: "Seattle, Washington"
    },
    {
  id: 8,
  title: "Vishwashanti Mahotsav 2025: Phoenix",
  subtitle: "A Celebration of Devotion, Unity, and Peace",
  date: "November 14, 2025",
  endDate: "2025-11-14",
  thumbnail: vishwashantiPhoenix,
  photos: [vishwashantiPhoenix],
  videos: [],
  description: "The Vishwashanti Mahotsav 2025 was celebrated with devotion and enthusiasm in Phoenix, bringing together Swami devotees, families, and community leaders for a spiritually uplifting event.",
  fullContent: `
    <h3>🙏 Vishwashanti Mahotsav 2025 Celebrated in Phoenix!</h3>
    <p>The Vishwashanti Mahotsav 2025 was celebrated with devotion and enthusiasm in Phoenix, bringing together Swami devotees, families, and community leaders for a spiritually uplifting event. Spiritual guidance and discourse by Hon. Dr. Nitinbhau deeply inspired all attendees.</p>

    <h4>✨ Program Features:</h4>
    <ul>
      <li>Sacred rituals including Paduka Pujan and Chakraraj Shreeyantra Pujan</li>
      <li>Matru-Pitru Pujan and Saraswati Pujan for kids</li>
      <li>Bal Sanskar activities and Youth Volunteer initiatives</li>
      <li>Palakhi procession and Food Donation Drive</li>
      <li>Maha-Aarti and Maha-Prasad</li>
    </ul>

    <h4>🌟 Distinguished Guests:</h4>
    <p>The program was graced by:</p>
    <ul>
      <li>Office bearers and devotees of Shree Shirdi Sai Baba Temple (North Phoenix)</li>
      <li>Harshad Desai (Phoenix Metro Maharashtra Mandal)</li>
      <li>Sushma Thakur-Patankar (AVATAR Theaters of Arizona)</li>
      <li>Prasad Koranne (Sewa International & HSS)</li>
      <li>Dipali Mandalkar (Shree Gajanan Maharaj Pariwar)</li>
      <li>Ratnavali Patne (President, Chhatrapati Shivaji Maharaj Antarashtreey Pariwar) with her team</li>
    </ul>

    <p>The Mahotsav radiated peace, devotion, and unity, spreading His Holiness Gurumauli's message of Swami Seva, Sanskar, and Shanti across the Phoenix community.</p>
  `,
  venue: {
    name: "Phoenix",
    address: "Phoenix, Arizona, USA",
    mapLink: "https://maps.google.com/?q=Phoenix+Arizona"
  },
  highlights: [
    "Paduka Pujan and Chakraraj Shreeyantra Pujan",
    "Matru-Pitru Pujan and Bal Sanskar activities",
    "Food Donation Drive",
    "Presence of distinguished community leaders",
    "Inspiring discourse by Hon. Dr. Nitinbhau"
  ],
  timings: "Full Day Event",
  location: "Phoenix, Arizona"
},
{
  id: 9,
  title: "Vishwashanti Mahotsav 2025: Atlanta",
  subtitle: "Seva and Sanskar - The Purest Form of Worship",
  date: "November 15, 2025",
  endDate: "2025-11-15",
  thumbnail: vishwashantiAtlanta,
  photos: [vishwashantiAtlanta],
  videos: [],
  description: "The Vishwashanti Mahotsav 2025 was celebrated with great devotion in Atlanta on November 15, 2025, where hundreds of Swami devotees from ten different USA states warmly welcomed Hon. Dr. Nitinbhau along with the sacred 'Paduka of Shree Swami Samarth Maharaj' from 'Shree Gurupeeth'.",
  fullContent: `
    <h3>🙏 Vishwashanti Mahotsav 2025: Atlanta, Georgia</h3>
    <p>The Vishwashanti Mahotsav 2025 was celebrated with great devotion in Atlanta on November 15, 2025, where hundreds of Swami devotees from ten different USA states warmly welcomed Hon. Dr. Nitinbhau along with the sacred 'Paduka of Shree Swami Samarth Maharaj' from 'Shree Gurupeeth'.</p>

    <h4>✨ Event Highlights:</h4>
    <ul>
      <li>With great devotion, devotees participated in the sacred Seva of Shree Chakraraj Shreeyantra Poojan</li>
      <li>Event began with Paduka Pujan and Chakraraj Shreeyantra Pujan</li>
      <li>Maha Aarti and collective Vishwashanti Prarthana for global peace</li>
      <li>Hon. Dr. Nitinbhau delivered an inspiring discourse</li>
      <li>Devotional Palakhi procession</li>
      <li>Children and youth participated in Matru-Pitru Pujan, Saraswati Pujan, festival displays, exhibitions, and career guidance activities</li>
      <li>BalSanskar children presented inspiring cultural performances, including a special act on Bhakt Pundalik</li>
    </ul>

    <h4>🎯 Message by Hon. Dr. Nitinbhau:</h4>
    <p>Hon. Dr. Nitinbhau delivered an inspiring discourse, emphasizing that Seva and Sanskar are the purest form of worship, and offering practical guidance for parents and youth. His message deeply inspired all attendees.</p>

    <h4>🎁 Special Distribution:</h4>
    <p>Devotees also received the 2026 calendar and a special blessing kit.</p>

    <p>The cultural performances by BalSanskar children, including a special act on Bhakt Pundalik, beautifully reflected Shree Gurupeeth's mission of nurturing value-based education.</p>
  `,
  venue: {
    name: "Atlanta",
    address: "Atlanta, Georgia, USA",
    mapLink: "https://maps.google.com/?q=Atlanta+Georgia"
  },
  highlights: [
    "Devotees from 10 USA states in attendance",
    "Seva and Sanskar - The purest form of worship",
    "BalSanskar - Bhakt Pundalik performance",
    "Career guidance and youth initiatives",
    "2026 calendar and blessing kit distribution"
  ],
  timings: "Full Day Event",
  location: "Atlanta, Georgia"
},
{
  id: 10,
  title: "Vishwashanti Mahotsav 2025: Brampton, Canada",
  subtitle: "From USA to Canada—A Unified Wave of Spiritual Harmony",
  date: "November 16, 2025",
  endDate: "2025-11-16",
  thumbnail: vishwashantiBrampton,
  photos: [vishwashantiBrampton],
  videos: [],
  description: "Following the successful Vishwashanti Mahotsav celebrations across the USA, the spiritual wave of Seva, Sanskar, and Shanti reached Brampton, Canada, where the Vishwashanti Mahotsav 2025 was celebrated with devotion and enthusiasm on November 16, 2025.",
  fullContent: `
    <h3>🙏 From USA to Canada—A Unified Wave of Spiritual Harmony</h3>
    <h4>Vishwashanti Mahotsav 2025: Brampton, Canada</h4>

    <p>Following the successful Vishwashanti Mahotsav celebrations across the USA, the spiritual wave of Seva, Sanskar, and Shanti reached Brampton, Canada, where the Vishwashanti Mahotsav 2025 was celebrated with devotion and enthusiasm on November 16, 2025.</p>

    <h4>✨ Event Highlights:</h4>
    <ul>
      <li>Hon. Dr. Nitinbhau guided the devotees on spirituality and inner peace</li>
      <li>Practical insights to strengthen family and community values</li>
      <li>Devotees gathered in large numbers to participate in Paduka Pujan, cultural presentations, and Vishwashanti Prarthana</li>
      <li>Atmosphere of unity and peace created throughout the event</li>
    </ul>

    <h4>🌟 Distinguished Guests:</h4>
    <ul>
      <li>Mr. Murarilal Thapliaal, President and Founder-President of the Sanatan Board Canada</li>
      <li>Mr. Deepak Malik, Chairman and newly elected Board Director of the Indo-Canada Chamber of Commerce</li>
    </ul>

    <h4>🎨 Cultural Activities:</h4>
    <p>Matru-Pitru Poojan, Shree Chakraraj Shreeyantra Poojan, Bal Sanskar performances, and devotional activities beautifully reflected Shree Gurupeeth's mission of spreading Seva, Sanskar, and Shanti.</p>

    <h4>🙏 Conclusion:</h4>
    <p>The Mahotsav concluded with a collective prayer for global harmony, and devotees received the 2026 calendar and a special blessing kit.</p>
  `,
  venue: {
    name: "Brampton",
    address: "Brampton, Ontario, Canada",
    mapLink: "https://maps.google.com/?q=Brampton+Ontario+Canada"
  },
  highlights: [
    "USA to Canada - Spiritual wave continues",
    "Guidance by Hon. Dr. Nitinbhau",
    "Sanatan Board Canada & Indo-Canada Chamber representatives",
    "Matru-Pitru Poojan & Bal Sanskar",
    "Collective prayer for global harmony"
  ],
  timings: "Full Day Event",
  location: "Brampton, Canada"
},
{
  id: 11,
  title: "Vishwashanti Mahotsav 2025: Newcastle, UK",
  subtitle: "Carrying Swami's Message of Seva and Shanti to the UK",
  date: "November 18, 2025",
  endDate: "2025-11-18",
  thumbnail: vishwashantiNewcastle,
  photos: [vishwashantiNewcastle],
  videos: [],
  description: "Hon. Dr. Nitinbhau and Shree Swami Samarth Seva Marg were warmly welcomed at Newcastle, UK, where the Vishwashanti Mahotsav 2025 was celebrated with immense devotion and enthusiasm.",
  fullContent: `
    <h3>🙏 Carrying Swami's Message of Seva and Shanti to the UK</h3>
    <h4>Vishwashanti Mahotsav - Newcastle, UK - 2025</h4>

    <p>Hon. Dr. Nitinbhau and Shree Swami Samarth Seva Marg were warmly welcomed at Newcastle, UK, where the Vishwashanti Mahotsav 2025 was celebrated with immense devotion and enthusiasm.</p>

    <h4>✨ Inspiring Discourse by Hon. Dr. Nitinbhau:</h4>
    <p>Hon. Dr. Nitinbhau delivered an inspiring discourse, emphasizing peace, inner strength, and the importance of Seva and Sanskar in nurturing strong families and communities.</p>

    <h4>🌺 Program Schedule:</h4>
    <ul>
      <li>Warm welcome and Aagman ceremony</li>
      <li>Bal Sanskar and kids' cultural performances</li>
      <li>Palakhi Seva</li>
      <li>Sacred Shree Chakraraj Shreeyantra Poojan for financial prosperity</li>
      <li>One-to-one counselling (Prashnottar) sessions with Hon. Dr. Nitinbhau</li>
      <li>Maha Prasad</li>
    </ul>

    <h4>🎯 Major Highlight:</h4>
    <p>A major highlight of the event was the one-to-one counselling (Prashnottar) sessions with Hon. Dr. Nitinbhau, which drew tremendous interest and provided clarity on various spiritual and personal issues.</p>

    <p>The Mahotsav concluded with Maha Prasad, leaving devotees filled with peace, gratitude, and the divine message of Vishwashanti.</p>
  `,
  venue: {
    name: "Newcastle",
    address: "Newcastle, United Kingdom",
    mapLink: "https://maps.google.com/?q=Newcastle+United+Kingdom"
  },
  highlights: [
    "Inspiring discourse by Hon. Dr. Nitinbhau",
    "Bal Sanskar and kids' performances",
    "Shree Chakraraj Shreeyantra Poojan",
    "One-to-one counselling sessions (Prashnottar)",
    "Carrying Swami's message of Seva and Shanti to UK"
  ],
  timings: "Full Day Event",
  location: "Newcastle, UK"
},
{
  id: 12,
  title: "Shree Datta Jayanti - Akhand Nam-Jap-Yadnya  Week",
  subtitle: "At Shree Gurupeeth Trimbakeshwar & Sacred Kshetras",
  date: "November 28, 2025",
  endDate: "2025-12-05",
  thumbnail: dattaJayantiAkhandJap,
  photos: [dattaJayantiAkhandJap],
  videos: [],
  description: "With the divine blessings of His Holiness Gurumauli, Akhand Nam-Jap-Yadnya  Week is being organized at Shree Gurupeeth Trimbakeshwar, Shree Kshetra Nrusinhawadi, Shree Kshetra Ganagapur, and Shree Kshetra Pithapuram from November 28, 2025 to December 5, 2025 on the auspicious occasion of Shree Datta Jayanti.",
  fullContent: `
    <h3>!! Shree Swami Samarth !!</h3>
    <h4>Shree Datta Jayanti - Akhand Nam-Jap-Yadnya  Week</h4>

    <p>With the divine blessings and grace of His Holiness Gurumauli, Akhand Nam-Jap-Yadnya  Week is being organized at the following sacred locations on the auspicious occasion of Shree Datta Jayanti:</p>

    <h4>📍 Locations:</h4>
    <ul>
      <li>Shree Gurupeeth Trimbakeshwar</li>
      <li>Shree Kshetra Nrusinhawadi</li>
      <li>Shree Kshetra Ganagapur</li>
      <li>Shree Kshetra Pithapuram</li>
    </ul>

    <h4>📅 Duration:</h4>
    <p><strong>November 28, 2025 to December 5, 2025</strong></p>

    <h4>🙏 How to Participate:</h4>
    <p>Devotees who wish to participate in this sacred seva should register their names using the link provided below and take advantage of this golden opportunity.</p>

    <h4>📞 Contact Numbers:</h4>
    <ul>
      <li>1. Shree Gurupeeth Trimbakeshwar - 8263919200</li>
      <li>2. Shree Kshetra Nrusinhawadi - 9226538427</li>
      <li>3. Shree Kshetra Ganagapur - 9226538428 / 9226538426</li>
      <li>4. Shree Kshetra Pithapuram - 7447436021 / 9022061699</li>
    </ul>

    <h4>📝 Registration:</h4>
    <p>Please register your name at the following link:<br>
    <a href="https://surveyheart.com/form/691c2ed003886962932dc7d0" target="_blank">https://surveyheart.com/form/691c2ed003886962932dc7d0</a></p>

    <h4>✨ Significance of Akhand Namjap Yagna:</h4>
    <p>This Akhand Namjap Yagna being conducted on the occasion of Shree Datta Jayanti is extremely meritorious and beneficial. Participate in this sacred seva and receive the blessings of Lord Dattatreya.</p>
  `,
  registerlink : 'https://surveyheart.com/form/691c2ed003886962932dc7d0',
  venue: {
    name: "Four Sacred Kshetras",
    address: "Shree Gurupeeth Trimbakeshwar, Nrusinhawadi, Ganagapur, Pithapuram",
    mapLink: "https://maps.app.goo.gl/HG5qHR3WwQLivnpT8"
  },
  highlights: [
    "With blessings of His Holiness Gurumauli",
    "Simultaneously at four sacred locations",
    "November 28 to December 5 - 8-day Yagna",
    "Online registration facility available",
    "Shree Datta Jayanti Special"
  ],
  timings: "November 28, 2025 to December 5, 2025",
  location: "Trimbakeshwar, Nrusinhawadi, Ganagapur, Pithapur"
},
 {
      id: 13,
      title: "Shree Kshetra Pithapuram - One-Day Shri Gurucharitra Parayan & Shri Siddhamangal Paduka Pujan",
      subtitle: "Special Pujan on the Auspicious Occasion of Shree Anaghashtami",
      date: "December 11, 2025",
      endDate: "2025-12-11",
      thumbnail: pithapurPadukaPujan,
      photos: [pithapurPadukaPujan],
      videos: [],
      description: "With the divine blessings of His Holiness Gurumauli and in the gracious presence of revered Shri Dadasaheb, a special one-day Havan with Shri Gurucharitra Parayan and Shri Siddhamangal Paduka Pujan is being organized at Shree Kshetra Pithapur, Andhra Pradesh on Thursday, December 11, 2025.",
      fullContent: `
        <h3>‼️ Shree Swami Samarth ‼️</h3>
        <h4>Akhil Bharatiya Shree Swami Samarth Gurupeeth, Trimbakeshwar, Dist. Nashik</h4>

        <p>With the divine grace and blessings of His Holiness Gurumauli and in the august presence of revered Shri Dadasaheb, a special <strong>One-Day Havan with Shri Gurucharitra Parayan and Shri Siddhamangal Paduka Pujan</strong> is being organized on Thursday, <strong>December 11, 2025</strong> at <strong>Shree Kshetra Pithapur, Andhra Pradesh</strong>.</p>

        <p>At the sacred birthplace of Parabrahma Shreepada Shreevallabha – Shree Kshetra Pithapur – on the holy occasion of Shree Anaghashtami, devotees must participate in this pujan to resolve issues related to marriage, career, health, education, and many incurable problems. During this pujan, the divine Paduka of the Lord are placed on the devotee’s head, removing negative energies and eliminating all kinds of obstacles and doshas.</p>

        <h4>📌 A Rare Divine Opportunity – Everyone Must Avail This Blessing!</h4>

        <p><strong>Registration Link:</strong><br>
        <a href="https://surveyheart.com/form/6922da15566e2c0e996f8f99" target="_blank">https://surveyheart.com/form/6922da15566e2c0e996f8f99</a></p>

        <p>We humbly request all devotees to participate in this rare and highly meritorious pujan and receive the divine blessings of Shree Swami Samarth Maharaj and Shreepada Shreevallabha.</p>
      `,
      registerlink : 'https://surveyheart.com/form/6922da15566e2c0e996f8f99',
      venue: {
        name: "Shree Kshetra Pithapuram",
        address: "Pithapuram, Andhra Pradesh, India",
        mapLink: "https://maps.app.goo.gl/DWMiMJ3TXyzEZBdZ9"   // ← Update with actual map link if available
      },
      highlights: [
                "Special pujan on Shree Anaghashtami",
                "Havan with complete Shri Gurucharitra Parayan",
                "Divine Siddhamangal Paduka blessings",
                "Guidance and spiritual support for marriage, career, health, education & life challenges",
                "Organized at the birthplace of Shreepada Shreevallabha"
              ],
      timings: "December 11, 2025 (Full Day)",
      location: "Shree Kshetra Pithapuram, Andhra Pradesh",
      registerLink: "https://surveyheart.com/form/6922da15566e2c0e996f8f99"
 },
 {
  id: 14,
  title: "Shri Kshetra Gangapur - One Day Havan with Shri Gurucharitra Parayan and Shri Anagha Datta Siddhapaduka Pujan Ceremony",
  subtitle: "Special Event for Shri Gurupratipada (Shailyagaman)",
  date: "February 2, 2026",
  endDate: "2026-02-02",
  thumbnail: GurucharitaGangapurImage,
  photos: [GurucharitaGangapurImage],
  videos: [],
  description: "Akhil Bharatiya Shri Swami Samarth Gurupith, Trimbakeshwar, Nashik is organizing a one-day Havan with Shri Gurucharitra Parayan and Shri Anagha Datta Siddhapaduka Pujan Ceremony at Dattadham, Shri Kshetra Gangapur, Karnataka on the auspicious occasion of Shri Gurupratipada (Shailyagaman).",
  fullContent: `
    <h3>‼️ Shri Swami Samarth ‼️</h3>
    <h4>Akhil Bharatiya Shri Swami Samarth Gurupith, Trimbakeshwar, Nashik</h4>
    <h4>Special Event for Shri Gurupratipada (Shailyagaman)</h4>

    <p><strong>📅 Date: February 2, 2026</strong></p>

    <h3>🔥 Program Details:</h3>
    <ul>
      <li>One Day Havan with Shri Gurucharitra Parayan</li>
      <li>🙏 Shri Anagha Datta Siddhapaduka Pujan Ceremony (Shri Siddhamangal Paduka Pujan)</li>
    </ul>

    <h3>📍 Venue:</h3>
    <p>Dattadham, Shri Kshetra Gangapur, Karnataka</p>

    <h3>📦 Items to Bring:</h3>
    <ul>
      <li>Shri Gurucharitra Book</li>
      <li>Prayer Beads (Japmala)</li>
      <li>Sitting Mat (Asan)</li>
      <li>Daily Worship Items (Nityaseva)</li>
    </ul>

    <h3>📞 For More Information Contact:</h3>
    <p>7020478721 | 7796926111</p>

    <h4>📌 Special Notice:</h4>
    <p>Representatives of all 18 departments should extensively promote this service, and devotees should take maximum benefit of this divine opportunity.</p>

    <p><strong>Name Registration:</strong><br>
    <a href="https://form.svhrt.com/6922da15566e2c0e996f8f99" target="_blank">https://form.svhrt.com/6922da15566e2c0e996f8f99</a></p>

    <h4>🙏 Rare Divine Opportunity - Everyone Should Participate!</h4>
  `,
  registerlink: 'https://form.svhrt.com/6922da15566e2c0e996f8f99',
  venue: {
    name: "Dattadham, Shri Kshetra Gangapur",
    address: "Gangapur, Karnataka",
    mapLink: "https://maps.app.goo.gl/4dG8cvMgyPHFLMLz8"  // Add Google Maps link if available
  },
  highlights: [
    "Special worship on Shri Gurupratipada (Shailyagaman)",
    "One Day Havan with Shri Gurucharitra Parayan",
    "Shri Anagha Datta Siddhapaduka Pujan Ceremony",
    "Shri Siddhamangal Paduka Pujan",
    "Event at Dattadham, Shri Kshetra Gangapur"
  ],
  timings: "February 2, 2026 (Full Day)",
  location: "Dattadham, Shri Kshetra Gangapur, Karnataka",
  registerLink: "https://form.svhrt.com/6922da15566e2c0e996f8f99",
  contactNumbers: ["7020478721", "7796926111"],
  itemsToBring: [
    "Shri Gurucharitra Book",
    "Prayer Beads (Japmala)",
    "Sitting Mat (Asan)",
    "Daily Worship Items (Nityaseva)"
  ]
}
  ]
};